import { CssBaseline, Box } from "@mui/material";
import { useLocation } from "react-router-dom";
import useWidth from "../hooks/useWidth";
import NavbarComponent from "./navbar.component";
import FooterComponent from "./footer.component";
import HudOverlay from "../component/animations/HudOverlay";

function Main({ children }) {
    const url = window.location.pathname;
    const breakpoints = useWidth();

    return (
        <Box
            sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                background: url === "/view/pdf" ? "#80808021" : {},
            }}
        >
            <Box
                sx={{
                    width: "100%",
                    overflowY: breakpoints === "xs" || breakpoints === "sm" ? {} : "hidden",
                    height: "100%",
                }}
            >
                {children}
            </Box>
        </Box>
    );
}

function MainLayout({ children }) {
    const location = useLocation();
    const { pathname } = location;

    return (
        <>
            <CssBaseline />
            <NavbarComponent />
            {children}
            <FooterComponent />
        </>
    );
}

export default MainLayout;
